var map = {
	"./exam.js": "./src/router/modules/exam.js",
	"./pennonAgent.js": "./src/router/modules/pennonAgent.js",
	"./schoolHome.js": "./src/router/modules/schoolHome.js",
	"./student.js": "./src/router/modules/student.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/router/modules sync recursive \\.js$";